var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNotEqual = function SvgNotEqual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "not equal",
    d: "M1.5 8.61h3.68l1.63-3.22H1.5V3.5h6.27L9.35.35l1.59.87L9.78 3.5h2.72v1.89H8.82L7.19 8.61h5.31v1.89H6.23l-1.58 3.15-1.59-.87 1.16-2.28H1.5Z"
  })));
};

export default SvgNotEqual;